import React, { useEffect, useState } from "react";
import PubSub from "pubsub-js";
import AddToCart from "../shop/AddToCart";
import SanityImage from "../SanityImage";
import SanityPortableText from "../SanityPortableText";

const ProductUI = ({ input }) => {
  const { showImage, product, color } = input;
  const { title, texte, description, images, productDrop } = product;

  let _canPurchase = true;
  const isDrop = productDrop && productDrop.dropDate;
  // console.log(productDrop);
  if (isDrop) {
    // console.log(productDrop);
    _canPurchase = productDrop.seconds >= 0;
  }
  // console.log("canPurchase", _canPurchase);

  const [canPurchase, setCanPurchase] = useState(_canPurchase);

  useEffect(() => {
    const token = PubSub.subscribe("COUNDOWN_END", () => {
      setCanPurchase(true);
    });
    return () => PubSub.unsubscribe(token);
  }, []);
  // console.log(images);

  return (
    <section
      className='productUI section product scrollY'
      style={{
        backgroundColor: color ? color : "transparent"
      }}>
      <div className='inner'>
        {showImage && (
          <div className='mb-md toggle'>
            <SanityImage input={{ image: images[0] }} />
          </div>
        )}
        <div className='p-md'>
          <div className='row'>
            <div className='col-md-6 col-xs-12'>
              <div className='texte pr-md text-sm'>
                {description && <SanityPortableText input={description} />}
              </div>
            </div>
            <div className='col-md-6 col-xs-12'>
              {canPurchase && <AddToCart input={product} />}
              {/* {isDrop && !canPurchase && <div>Coming sooon ...</div>} */}
            </div>
          </div>
        </div>
        <h2 className='text-sm-lg md:text-lg mb-lg px-md'>{title}</h2>
        {texte && (
          <div className='pr-md pb-md pl-md'>
            <SanityPortableText input={texte} indentP />
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductUI;
